.body {
  margin-bottom: calc(var(--spacing) * 2);
}
